import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { fuelRefillsApi } from '@/api/fuelRefills';
import type { CreateFuelRefillInput } from '@/types/companyExtras';

export function useFuelRefills(params?: { limit?: number; offset?: number }) {
  return useQuery({
    queryKey: ['fuel-refills', 'mine', params?.limit, params?.offset],
    queryFn: () => fuelRefillsApi.listMine(params),
  });
}

export function useCreateFuelRefill() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateFuelRefillInput) => fuelRefillsApi.create(input),
    onSuccess: () => { void qc.invalidateQueries({ queryKey: ['fuel-refills'] }); },
  });
}
